import PropTypes from 'prop-types';

import { CustomizedHeader } from './styles';
// eslint-disable-next-line import/no-cycle
import CMSBasicContent from '../../OC/PageBuilder/BasicContent';

const Header = ({ copy }) => (
  <CustomizedHeader>
    <CMSBasicContent content={{ ...copy }} />
  </CustomizedHeader>
);

Header.propTypes = {
  copy: PropTypes.shape({
    className: PropTypes.string,
    prehead: PropTypes.string,
    heading: PropTypes.string,
    headingClass: PropTypes.string,
    posthead: PropTypes.string,
    bodyCopy: PropTypes.string,
  }).isRequired,
};

export default Header;
